import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient, APIResponse } from '../client';
import { Order } from '../queries/order.queries';

export interface UpdateOrderStatusInput {
  status: 'new' | 'in_progress' | 'ready' | 'completed' | 'cancelled';
}

// Update order status (for KDS workflow)
export function useUpdateOrderStatus(orderId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: UpdateOrderStatusInput) => {
      const response = await apiClient.patch<APIResponse<{ order: Order }>>(
        `/orders/${orderId}/status`,
        input
      );
      return response.data.data.order;
    },
    onSuccess: () => {
      // Invalidate all order-related queries to refresh KDS display
      queryClient.invalidateQueries({ queryKey: ['orders'] });
    },
  });
}

// Bulk update multiple orders (useful for batch operations)
export function useBulkUpdateOrderStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (orders: Array<{ orderId: string; status: string }>) => {
      const response = await apiClient.post<APIResponse<{ updated: number }>>(
        '/orders/bulk-status',
        { orders }
      );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['orders'] });
    },
  });
}
